import { useMutation, useQueryClient } from '@tanstack/react-query';
import { callbackFetch, url } from './fetch';
import updatePriceCache from './update-price-cache';
import updateAboutCache from './update-about-cache';

function useStockPrices() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [url],
    mutationFn: callbackFetch,
    onSuccess: (data) => {
      const stockData = data.results;
      updatePriceCache(queryClient, stockData);
      updateAboutCache(queryClient, stockData);
    },
  });
}

export default useStockPrices;
